export default "__VITE_ASSET__D34CH5IT__"